import { render, staticRenderFns } from "./Issues.vue?vue&type=template&id=6eb8cf1c&"
import script from "./Issues.vue?vue&type=script&lang=ts&"
export * from "./Issues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb8cf1c')) {
      api.createRecord('6eb8cf1c', component.options)
    } else {
      api.reload('6eb8cf1c', component.options)
    }
    module.hot.accept("./Issues.vue?vue&type=template&id=6eb8cf1c&", function () {
      api.rerender('6eb8cf1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/columns/Issues.vue"
export default component.exports